import React from 'react';
import ModalSendForRevision from '../../common/ModalSendForRevision';

export default function ModalRevisionExpert({ show, onSubmit, onClose }) {
  return (
    <ModalSendForRevision
      show={show}
      onSubmit={onSubmit}
      onClose={onClose}
      headerText="Возврат на доработку"
      label="Комментарий Проектного офиса"
    />
  );
}
